import { gql } from '@apollo/client';

export const FETCH_IS_IN_LMI_ZONE = gql`
  query Flex_FetchIsInLmiZone($utilityAccountId: Int!) {
    utilityAccount(id: $utilityAccountId) {
      lmiZoneOptions {
        isInLmiArea
        isInCensusTract
        error
      }
    }
  }
`;
